module.exports = __webpack_public_path__ + "static/media/B.ea13edd7.svg";